module.exports = __webpack_public_path__ + "img/guide_bg.13e4fb8b.jpg";